import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getPrivilegeById } from '@services/privilege.service';
import { IPrivilege } from '@interfaces/privilege';

export const fetchPrivilegeDetail = createAsyncThunk('voucher/getPrivilegeById', async (privilegeId: string) => {
	return await getPrivilegeById(privilegeId);
});

export interface PrivilegeDetailState {
	privilege: IPrivilege;
	isLoading: boolean;
}

const initialState = {
	privilege: {
		_id: '',
		category: [],
		type: '',
		title: '',
		startDate: '',
		endDate: '',
		outletsDetail: '',
		description: '',
		terms: '',
		tileImageUrl: '',
		bannerImageUrl: '',
		exclusiveGroup: '',
		wayToRedeem: '',
		howToRedeem: '',
		searchableKeywords: '',
		exclusiveBdayNumOfMonth: 0,
		status: '',
		numberOfRedemption: 0,
		link: '',
		tags: [],
	},
	isLoading: true,
} satisfies PrivilegeDetailState as PrivilegeDetailState;

const privilegeDetailSlice = createSlice({
	name: 'privilegeDetail',
	initialState: initialState,
	reducers: {
		fetchPrivilegeDetail: (state, action: PayloadAction<PrivilegeDetailState>) => {
			return {
				...state.privilege,
				...action.payload,
			};
		},
	},
	extraReducers(builder) {
		builder.addCase(fetchPrivilegeDetail.pending, (state: PrivilegeDetailState) => {
			state.isLoading = true;
		});
		builder.addCase(fetchPrivilegeDetail.fulfilled, (state: PrivilegeDetailState, action) => {
			state.privilege = (action.payload as any)['data'] ?? [];
			state.isLoading = false;
		});
		builder.addCase(fetchPrivilegeDetail.rejected, (state: PrivilegeDetailState) => {
			state.isLoading = false;
		});
	},
});

export const privilegeDetailReducer = privilegeDetailSlice.reducer;
export default privilegeDetailSlice;
